"use client";
import { useDisclosure } from "@nextui-org/react";
import Link from "next/link";
import BannerFooterShape from "../../assets/svg/BannerFooterShape";
import VectorBanner from "../../assets/svg/VectorBanner";
import { getLink } from "../../lib/util";
import EnquireModal from "../modal/EnquireModal";
import { ContentContainer } from "../molecules";
import dynamic from "next/dynamic";

const UpskillYourTeam = dynamic(() => import("../modal/UpskillYourTeam"));

const BaseBanner = ({
  title,
  description,
  footerContent,
  background,
  descriptionWidth,
  params,
}) => {
  const { isOpen, onOpenChange } = useDisclosure();

  const trackExploreOurCoursesClick = (menuName) => {
    webengage.track('ExploreOurCourses', {
      category: 'ExploreOurCourses',
      label: menuName,
      value: 1,
    });
  };
  return (
    <>
      <ContentContainer>
        {title && (
          <span className="absolute z-20 top-44 -left-5">
            <VectorBanner />
          </span>
        )}

        <div
          className="relative bg-cover bg-center bg-no-repeat h-[25rem] xl:h-[30rem] rounded-3xl flex items-start flex-col justify-between p-8 lg:p-16 mt-0 mb-10 lg:mb-20"
          style={{ backgroundImage: `url(${background})` }}
        >
          <h1 className="bannerHeading mb-2 max-w-full lg:max-w-[670px] text-white text-[32px] leading-[32px] lg:text-6xl font-extrabold lg:leading-tight">
            {title}
          </h1>
          <p
            className={`font-normal text-white tracking-[0.48px] leadig-[170%] w-[350px] max-w-[${
              descriptionWidth ? descriptionWidth : "350px"
            }]`}
          >
            {description}
          </p>

          {footerContent && (
            <div className="absolute -right-1 -bottom-1 z-10">
              <div className="mb-10">{footerContent}</div>
              <BannerFooterShape />
            </div>
          )}
          <div className="hidden lg:block absolute right-0 bottom-0 w-full max-w-[530px]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="631"
              height="107"
              viewBox="0 0 631 107"
              fill="none"
              className="absolute -bottom-[1px] right-0"
            >
              <path
                d="M59.1042 69.5C59.1042 48.7893 75.8935 32 96.6042 32H594.751C613.174 32 628.715 18.2812 631 0V107H0H21.6042C42.3149 107 59.1042 90.2107 59.1042 69.5Z"
                fill="white"
              />
            </svg>
            <div className="relative z-10 flex items-center gap-5 right-5 text-center">
              <Link
                href={getLink(`${params.lang}/browsecourses`)}
                className="bg-[#0096AC] text-white rounded-full py-4 px-10 text-base font-semibold max-w-full w-full"
                onClick={() => {
                  trackExploreOurCoursesClick(
                    'Explore Our Courses',
                  );
                }}
              >
                Explore our courses
              </Link>
              <UpskillYourTeam  className={"bg-[#0096AC] text-black border border-primary rounded-full py-4 px-10 text-base font-semibold border border-black w-full"}/>

            </div>
          </div>
        </div>
        <div className="flex lg:hidden relative z-10 items-center gap-5 lg:right-5 mb-10 flex-col">
          <Link
            href={getLink(`${params.lang}/browsecourses`)}
            className="bg-[#0096AC] text-white rounded-full  py-4 px-10 text-base font-semibold max-w-full w-full sm:w-2/3 text-center"
          >
            Explore our courses
          </Link>
          <Link
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              onOpenChange();
            }}
            className="bg-transparent text-black rounded-full  py-4 px-10 text-base font-semibold border-1 border-black w-full sm:w-2/3 text-center"
          >
            Enquire Now
          </Link>
        </div>
      </ContentContainer>
      {isOpen && (
        <EnquireModal isOpen={isOpen} onOpenChange={onOpenChange} course={[]} />
      )}
    </>
  );
};

export default BaseBanner;
